//Template.js
///////////////////////////////
//React & Material
import React,{useEffect} from 'react';

//Plugins
import styled from 'styled-components';
import HeroSection from '../../components/HeroSection';
import SelectedWork from '../../components/SelectedWork';
import AboutMe from '../../components/AboutMe';

import ThanksSection from '../../components/ThanksSection';
import MoreWork from '../../components/MoreWork';

import Projects from '../../projects/work.json'
//Component Imports

//////////////////////////////
//Styled components
const Spacer = styled.div `
  width: 100vw;
  height: ${props => props.height}px;
`
//////////////////////////////
//Component class
/**
 * Displays a template component
 */
function Home(props) {
  return (
  <React.Fragment>
    <HeroSection/>
    <div id='work'>
    <SelectedWork alignImage="right" project={Projects.selectedWork[0]} />
    </div>
    <SelectedWork alignImage="left" project={Projects.selectedWork[1]}/>
    <SelectedWork alignImage="top"  project={Projects.selectedWork[2]}/>
    <SelectedWork alignImage="right" project={Projects.selectedWork[3]} />
    <MoreWork/>
    <AboutMe/>
    <Spacer height="200"/>
    <ThanksSection/>
    
  </React.Fragment>
  )
}
export default Home;